import React, { useState, useEffect, useRef, useCallback } from "react";
import classNames from "classnames";
import "./style.scss";

const ProgressBar = ({ steps, withOpacity = false }) => {
  const [active, setActive] = useState(steps.find(step => step.active === true));
  const [marginLeft, setMarginLeft] = useState();
  const firstLabel = useRef();
  const firstNumber = useRef();

  useEffect(() => {
    calculateMargin();
  }, []);

  useEffect(() => {
    let activeCurrent = steps.find(step => step.active === true);
    setActive(activeCurrent);
  }, [steps]);
  const handleResize = useCallback(() => {
    calculateMargin();
  }, []);
  // Add event listeners for resize and fix margin left
  useEffect(() => {
    global.addEventListener("resize", handleResize);
    return () => {
      global.removeEventListener("resize", handleResize, false);
    };
  }, [handleResize]);
  const calculateMargin = () => {
    let widthFirstNode = firstNumber.current?.offsetWidth;
    let widthFirstLabel = firstLabel.current?.offsetWidth;
    let _marginLeft = -(widthFirstNode - widthFirstLabel) / 2;
    setMarginLeft(`${_marginLeft}px`);
  };

  const clickHandler = (step, i) => {
    if (step.done && !step.disabled) {
      setActive(step);
      window.location.href = step.route;
    } else return false;
  };
  // console.log(steps,active,"progressbar")

  const Steps = ({ steps }) => {
    return (
      <ul className={"list-unstyled multi-steps"}>
        {steps.map((step, i) => {
          let stpeClasses = classNames({
            "is-active": step.done && step.label === active?.label,
            done: step.done,
            disabled: step.disabled,
            "add-opacity": withOpacity && !step.active
          });

          return (
            <li className={stpeClasses} key={i} ref={i === 0 ? firstNumber : null}>
              <p to={step.route} linktype="internal" className="step-count" isdisabled={step.disabled.toString()} onClick={() => clickHandler(step, i)}>
                {i + 1}
              </p>
              <span className="step-title" ref={i === 0 ? firstLabel : null}>
                {step.label}
              </span>
            </li>
          );
        })}
      </ul>
    );
  };
  return (
    <div className="checkout-progressbar" style={{ marginLeft: "-30px" }}>
      <Steps steps={steps}></Steps>
    </div>
  );
};
export default ProgressBar;
